import { useState } from 'react';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import ConfirmTransactionStep from './components/ConfirmTransactionStep';
import PrivateCodeStep from './components/PrivateCodeStep';
import TicketsSelectionStep from './components/TicketsSelectionStep';
import SelectCardStep from './components/SelectCardStep';
import WaiversStep from './components/WaiversStep';
import { useMultiTierCheckout } from './context';
import { GoToStepFn, StepsId } from './types';
import SuccessStep from './components/SuccessStep';
import usePreventTabClose from 'legacy/common/hooks/usePreventTabClose';
import RequestScreeningStep from './components/RequestScreeningStep';
import SuccessRequestApprovalStep from './components/SuccessRequestApprovalStep';

/**
 * The checkout process is composed of multiple steps, each showing a different part of the checkout process.
 * STEPS is a map of step ids to their respective step components to be rendered inside the main checkout modal.
 */
const STEPS = {
  [StepsId.ConfirmTransactionStep]: ConfirmTransactionStep,
  [StepsId.PrivateCodeStep]: PrivateCodeStep,
  [StepsId.RequestScreeningStep]: RequestScreeningStep,
  [StepsId.SelectCardStep]: SelectCardStep,
  [StepsId.SuccessRequestApprovalStep]: SuccessRequestApprovalStep,
  [StepsId.SuccessStep]: SuccessStep,
  [StepsId.TicketsSelectionStep]: TicketsSelectionStep,
  [StepsId.WaiversStep]: WaiversStep
};

const MultiTierCheckoutModal = () => {
  const [currentStep, setCurrentStep] = useState(StepsId.TicketsSelectionStep);
  const {
    onClose,
    data: { checkoutSession, event }
  } = useMultiTierCheckout();

  usePreventTabClose({
    hasUnsavedChanges: checkoutSession.isConfirmingCheckout
  });

  // Retrieves the step component from the STEPS map.
  const StepComponent = STEPS[currentStep];

  /**
   * Function to navigate to a specific step.
   */
  const goToStep: GoToStepFn = (stepId) => {
    setCurrentStep(stepId);
  };

  return (
    <Modal
      visible
      type={!checkoutSession.isCheckoutSuccess && ModalType.SMALL}
      onClose={onClose}
      shouldStopModalClose={
        checkoutSession.isLoadingCheckout ||
        (checkoutSession.isCheckoutSuccess &&
          (!!event?.ticketNotesRequest || !!event?.googleForms))
      }
    >
      <StepComponent goToStep={goToStep} />
    </Modal>
  );
};

export default MultiTierCheckoutModal;
